import { definePreset } from '../types/portal-settings';

// Limousine customers book passenger transfers: items are people and luggage,
// not cargo, so `items` replaces `itemObjects` and there is no items page.
export default definePreset({
	pages: ['locations', 'contacts', 'map', 'reports', 'settings'],
	features: {
		twoFactorAuth: false,
		items: true,
		jobs: {
			enabled: true,
			fromDateDefault: 'lastWeek',
			toDateDefault: 'today',
			allowJobView: true,
			allowJobDetailsView: true,
			allowJobCreate: true,
			allowJobGuidedCreate: true,
			allowJobEdit: true,
		},
		locations: { enabled: true, allowView: true, allowCreate: true, allowEdit: true },
	},
});
